import { createFileRoute } from "@tanstack/react-router";
import { AdminSeite } from "@/components/AdminSeite";

/*
 * `/admin` — die Landeseite des Admin-Bereichs.
 *
 * Dünn wie die anderen Routen: die Seite liegt in `src/components/` und ist
 * dadurch ohne Router testbar. Kein `loader`, kein `beforeLoad` — den Zugang
 * erfragt die Komponente selbst über `/api/v1/me`, damit Lade-, Fehler- und
 * Zugangszustand derselben Stelle gehören, die sie anzeigt.
 *
 * ═══ Warum dieser Pfad genau so heißen MUSS ═══════════════════════════════
 *
 * `auth.SichtAdmin` ist `/admin`, und `Navigation.tsx` zeigt einen Punkt nur,
 * wenn dessen Pfad ein Schlüssel in `routesByPath` ist. Ohne diese Route
 * erschiene „Administration" im Kopf nicht — der Upload wäre gebaut und nur
 * über die getippte Adresse erreichbar.
 *
 * Die Schwesterroute heißt `admin_.upload.tsx` und NICHT `admin.upload.tsx`:
 * der Unterstrich löst sie aus dieser hier heraus. Ohne ihn würde diese Datei
 * zur Layout-Route, ihr Inhalt stünde auch über dem Upload, und `/admin`
 * selbst bräuchte eine zusätzliche Index-Route.
 */
export const Route = createFileRoute("/admin")({
  component: AdminSeite,
});
